export default "__VITE_ASSET__CQwpkngs__"